import {Tooltip, Button, Modal /* Checkbox, Form,Input, */} from "antd"
import Label from "components/Label"
import React, {useState} from "react"
import {CloseCircleTwoTone, DownCircleOutlined, InfoCircleTwoTone, UpCircleOutlined} from "@ant-design/icons"
import {useDispatch} from "react-redux"
import {drugDown, drugUp, excludeDrug} from "redux/graphSlice"
import DrugInfo from "components/graph/DrugInfo"
//import {notesService} from "services/notes.service"
import { useTranslation } from 'react-i18next';

export default function DrugHeader({drug, cssClass = ""}) {

	return (
		<div className="row_header">
			<UpButton drug={drug}/>
			<DownButton drug={drug}/>
			<NameModal drug={drug} cssClass={cssClass}/>
			<InfoModal drug={drug}/>
			<ExcludeModal drug={drug}/>
		</div>
	)
}

function isTouchDevice() {
	return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}


function UpButton({ drug }) {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [tooltipVisible, setTooltipVisible] = useState(false);
	const [tapped, setTapped] = useState(false);

	const isTouch = isTouchDevice();

	const handleClick = () => {
		if (isTouch && !tapped) {
			setTooltipVisible(true);
			setTapped(true);
		} else {
			dispatch(drugUp(drug));
			if (isTouch) {
				setTooltipVisible(false); // Optionally hide tooltip
				setTapped(false); // Reset tap state
			}
		}
	};

	return (
		<Tooltip
			title={t('tooltips.moveUp')}
			showArrow={false}
			visible={isTouch ? tooltipVisible : undefined} // Only control visibility on touch devices
			onVisibleChange={isTouch ? (visible) => setTooltipVisible(visible) : undefined}
		>
			<Button
				type="text"
				onClick={handleClick}
			>
				<UpCircleOutlined />
			</Button>
		</Tooltip>
	);
}

function DownButton({drug}) {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [tooltipVisible, setTooltipVisible] = useState(false);
	const [tapped, setTapped] = useState(false);
	const isTouch = isTouchDevice();

	const handleClick = () => {
		if (isTouch && !tapped) {
			setTooltipVisible(true);
			setTapped(true);
		} else {
			dispatch(drugDown(drug));
			if (isTouch) {
				setTooltipVisible(false);
				setTapped(false);
			}
		}
	};

	return (
		<Tooltip
			title={t('tooltips.moveDown')}
			showArrow={false}
			visible={isTouch ? tooltipVisible : undefined}
			onVisibleChange={isTouch ? (visible) => setTooltipVisible(visible) : undefined}
		>
			<Button type="text" onClick={handleClick}>
				<DownCircleOutlined />
			</Button>
		</Tooltip>
	);
}

function ExcludeModal({drug}) {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const [tooltipVisible, setTooltipVisible] = useState(false);
	const [tapped, setTapped] = useState(false);
	const isTouch = isTouchDevice();

	const handleClick = () => {
		if (isTouch && !tapped) {
			setTooltipVisible(true);
			setTapped(true);
		} else {
			dispatch(excludeDrug(drug));
			if (isTouch) {
				setTooltipVisible(false);
				setTapped(false);
			}
		}
	};

	return (
		<Tooltip
			title={t('tooltips.excludeDrug')}
			showArrow={false}
			visible={isTouch ? tooltipVisible : undefined}
			onVisibleChange={isTouch ? (visible) => setTooltipVisible(visible) : undefined}
		>
			<Button className="drug-exclude-button" size="large" type="text" onClick={handleClick}>
				<CloseCircleTwoTone twoToneColor="#ff0000" />
			</Button>
		</Tooltip>
	);
}

function InfoModal({drug}) {
	const [show, setShow] = useState(false)
	const { t } = useTranslation();

	const close = () => setShow(false)

	return (
		<div className="drug-info">
			<Button className="drug-info-button" size="large" type="text" onClick={() => setShow(true)}>
				<InfoCircleTwoTone/>
			</Button>
			<Modal title={t(drug)} visible={show} onClose={close} onCancel={close} footer={null} width="100%">
				<DrugInfo drug={drug}/>
			</Modal>
		</div>
	)
}

function NameModal({drug, cssClass = ""}) {
	const [show, setShow] = useState(false)
	const { t } = useTranslation();

	const close = () => setShow(false)

	return (
		<div className="drug-name">
			<Button className={`drug-name-button ${cssClass}`} size="large" type="text" onClick={() => setShow(true)}>
				<Label id={drug}/>
			</Button>
			<Modal title={t(drug)} visible={show} onClose={close} onCancel={close} footer={null} width="100%">
				<DrugInfo drug={drug}/>
			</Modal>
		</div>
	)
}
